
import { Button } from "@/components/ui/button";
import { FileIcon, FilesIcon } from "lucide-react";
import { toast } from "@/hooks/use-toast";
import { exportToCSV, exportToExcel } from "../../utils/exportData";
import { CharterSignatory } from "../../utils/types";

interface ExportButtonsProps {
  signatories: CharterSignatory[];
}

export const ExportButtons = ({ signatories }: ExportButtonsProps) => {
  const formatSignatoriesForExport = (signatories: CharterSignatory[]) => {
    return signatories.map(signatory => ({
      Prénom: signatory.first_name,
      Nom: signatory.last_name,
      Email: signatory.email,
      "Date de signature": new Date(signatory.created_at).toLocaleDateString('fr-FR'),
      "Numéro de signature": signatory.signature_number || 'N/A'
    }));
  };

  const handleExportToExcel = () => {
    if (signatories.length === 0) {
      toast({
        title: "Aucune donnée à exporter",
        description: "La liste des signataires est vide.",
        variant: "destructive",
      });
      return;
    }
    
    try {
      const formattedData = formatSignatoriesForExport(signatories);
      exportToExcel(formattedData, `signataires_export_${new Date().toISOString().split('T')[0]}`);
      toast({
        title: "Export réussi",
        description: "Le fichier Excel a été téléchargé.",
      });
    } catch (error) {
      toast({
        title: "Erreur lors de l'export",
        description: "Impossible d'exporter les données vers Excel.",
        variant: "destructive",
      });
    }
  };
  
  const handleExportToCSV = () => {
    if (signatories.length === 0) {
      toast({
        title: "Aucune donnée à exporter",
        description: "La liste des signataires est vide.",
        variant: "destructive",
      });
      return;
    }
    
    try {
      const formattedData = formatSignatoriesForExport(signatories);
      exportToCSV(formattedData, `signataires_export_${new Date().toISOString().split('T')[0]}`);
      toast({
        title: "Export réussi",
        description: "Le fichier CSV a été téléchargé.",
      });
    } catch (error) {
      toast({
        title: "Erreur lors de l'export",
        description: "Impossible d'exporter les données vers CSV.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Button 
        onClick={handleExportToExcel}
        variant="outline" 
        className="flex items-center gap-2"
        disabled={signatories.length === 0}
      >
        <FileIcon size={18} />
        Excel
      </Button>
      <Button 
        onClick={handleExportToCSV}
        variant="outline" 
        className="flex items-center gap-2"
        disabled={signatories.length === 0}
      >
        <FilesIcon size={18} />
        CSV
      </Button>
    </div>
  );
};
